import { Box } from "@mui/material";
import {
  getInfoMaintenance,
  getMessageMaintenance,
} from "../../../../services/Config";
import styles from "./styles";

function BlocMaintenance() {
  return (
    <Box className={"container"} sx={styles}>
      {getInfoMaintenance() === "true" && (
        <div className={"maintenanceTexte"}>
          <h2>INFORMATION</h2>
          <h3>{getMessageMaintenance()}</h3>
          {/* <div className={classes.divider} /> */}
        </div>
      )}
    </Box>
  );
}

export default BlocMaintenance;
